import React from 'react';
import { GuestSiteEventDesign } from '../../../layout.types';
import { brannanConfig, useBrannanDesign } from '../../LayoutBrannan.theme';
import { FrameInner, FrameOuter } from '../Frames';
import { Page } from '../Page';

const { layerBack, layerMiddle } = brannanConfig.applicatorHtmlProps;

export interface ShellProps {
  eventDesign?: GuestSiteEventDesign;
  noTranslucency?: boolean;
}

export const Shell: React.FC<ShellProps> = ({ eventDesign, noTranslucency, children }) => {
  const { applicatorConfig, loading, CustomStyle } = useBrannanDesign(eventDesign);

  return (
    <FrameOuter loading={loading} applicatorProp={layerBack.prop}>
      {CustomStyle && <CustomStyle />}
      <FrameInner>
        <Page applicatorProp={layerMiddle.prop} showBorder={applicatorConfig?.layerMiddle.border?.isEnabled} noTranslucency={noTranslucency}>
          {children}
        </Page>
      </FrameInner>
    </FrameOuter>
  );
};
